"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmCalendarDay = void 0;
const classnames_1 = __importDefault(require("classnames"));
const date_fns_1 = require("date-fns");
const react_1 = __importDefault(require("react"));
const SmCalendarDay = (_a) => {
    var { date, selected, renderDay, className, between, today, holiday, trail, outside } = _a, props = __rest(_a, ["date", "selected", "renderDay", "className", "between", "today", "holiday", "trail", "outside"]);
    const dayButtonClassnames = (0, classnames_1.default)('c-calendar__gridCell', {
        '-selected': selected === null || selected === void 0 ? void 0 : selected.status,
        '-between': between,
        '-today': today,
        '-holiday': holiday,
        '-outside': outside,
        '-trail': trail,
        [`-${selected === null || selected === void 0 ? void 0 : selected.order}`]: selected === null || selected === void 0 ? void 0 : selected.order,
    }, className);
    return date ? (react_1.default.createElement("button", Object.assign({}, props, { type: "button", className: dayButtonClassnames, tabIndex: -1, role: "gridcell", "aria-selected": (selected === null || selected === void 0 ? void 0 : selected.status) || between }), renderDay ? (renderDay(date)) : (react_1.default.createElement("span", null, date ? (0, date_fns_1.format)(date, 'dd') : '')))) : (react_1.default.createElement("div", null));
};
exports.SmCalendarDay = SmCalendarDay;
//# sourceMappingURL=SmCalendarDay.js.map